export const columns = [
  {
    title: "Nombre",
    dataIndex: "nombre",
    width: "30%",
  },
  {
    title: "Descripción",
    dataIndex: "descripcion",
    width: "70%",
  },
];
export const formatData = (data) => {
  return {
    idEstadoMovimiento: data.id,
    esmo_nombre: data.nombre,
    esmo_descripcion: data.descripcion,
  };
};

export const camposFormulario = {
  title: "Estados de movimiento",
  campos: [
    {
      name: "idEstadoMovimiento",
      label: "id",
      type: "number",
      hidden: true,
    },
    {
      name: "esmo_nombre",
      label: "Nombre del estado de movimiento",
      type: "text",
      rules: [
        {
          required: true,
          message: "El nombre del estado de movimiento es obligatorio",
        },
        {
          max: 45,
          message: "El nombre no puede exceder los 45 caracteres",
        },
        {
          min: 1,
          message: "El nombre debe tener al menos 1 caracter",
        },
      ],
    },
    {
      name: "esmo_descripcion",
      label: "Descripción",
      type: "text",
      rules: [
        {
          required: true,
          message: "La descripción es obligatoria",
        },
      ],
    },
  ],
};
export const camposFilter = {
  title: "Estados de movimiento",
  campos: [
    {
      name: "esmo_nombre",
      type: "text",
      placeholder: "Nombre del estado de movimiento",
      rules: [
        {
          max: 45,
          message: "El nombre no puede exceder los 45 caracteres",
        },
      ],
    },
  ],
};
